import type { ReactNode } from 'react';
import React from 'react';
import { ThemeProvider } from '@emotion/react';

import { getTheme } from './utils';

// This component can be used to to simplify imports since it only requires
// one import instead of an import for the ThemeProvider and the getThem function
export const PaypalThemedProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => (
  <ThemeProvider theme={getTheme('ppReactV7')}>{children}</ThemeProvider>
);
